<script lang="ts">
    import SubField from "./inputfields/SubField.svelte"
    export let page: TaskStepPage,
        fullPath: string,
        value: any = {}
    if (!value) value = {}
</script>

<div class="grid">
    {#each page.subFields || [] as subField}
        <div class="field field-{subField.widget} {subField.size ? subField.size : 'col-12'}">
            <SubField
                fullPath="{fullPath}"
                subField="{subField}"
                bind:value="{value}"
            />
        </div>
    {/each}
</div>

<style lang="less">
    .row {
    }
</style>
